<template>
  <div class="device-wrapper">

    <!--操作按钮-->
    <div class="op-wrapper custom-wrapper"
      v-if="hasRes('dev_batch_add') || hasRes('dev_bind_url')">
      <el-button
        type="danger"
        size="medium"
        @click="batchAddDialogVisible = true"
        v-if="hasRes('dev_batch_add')">批量添加设备</el-button>
      <el-button
        type="danger"
        size="medium"
        @click="bindUrlDialogVisible = true"
        v-if="hasRes('dev_bind_url')">生成设备绑定二维码</el-button>
    </div>

    <dev-filter-form
      @filter="updateTableData"
      v-if="hasRes('dev_index')" />

    <!--表格-->
    <custom-table
      :data="deviceList"
      :fetch="false"
      v-if="hasRes('dev_index')"
      @selection-change="onSelectionChange"
      @data-change="updateTableData" >

      <el-table-column
        type="selection"
        width="55">
      </el-table-column>

      <el-table-column
        prop="sn"
        label="设备号"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              IMEI: {{ scope.row.clientid }}<br/>
              ICCID: {{ scope.row.icc_id }}<br/>
              MAC: {{ scope.row.mac_id }} <br/>
              设备厂商：{{ scope.row.factories.length > 0 ? scope.row.factories[0].name : '未知' }}<br/>
              信号值: {{ scope.row.alive === 0 ? 0 : scope.row.rssi }}<br/>
              设备类型：{{ scope.row.type in typesEnum ? typesEnum[scope.row.type] : scope.row.type }}<br/>
              版本号：{{ scope.row.dev_details.length > 0 && 'version' in scope.row.dev_details[0] ?
                scope.row.dev_details[0].version : '未知版本' }}<br/>
              MCU 版本号：{{ scope.row.dev_details.length > 0 && 'mversion' in scope.row.dev_details[0] ?
                scope.row.dev_details[0].mversion : '未知版本' }}<br/>
              通讯协议：{{ scope.row.protocol }}<br/>
              通讯是否加密：{{ scope.row.conn_encry === 0 ? '不加密' : '加密' }} <br/>
              代理商ID：{{ scope.row.agents[0].agentid }} <br/>
              代理商：{{ scope.row.agents[0].agentname }} <br/>
              代理商昵称：{{ scope.row.agents[0].nickname }}
            </div>
            <span>
              {{ scope.row.sn }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="title"
        label="设备名"
        sortable="custom" >
      </el-table-column>

      <el-table-column
        prop="userid"
        label="用户名"
        align="center"
        header-align="center"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tooltip placement="top" v-if="scope.row.users.length > 0">
            <div slot="content">
              商户ID: {{ scope.row.users[0].userid }} <br/>
              商户昵称: {{ scope.row.users[0].alias || '未设置' }}
            </div>
            <span>
              {{ scope.row.users[0].username }}
            </span>
          </el-tooltip>
          <span v-else> 未绑定 </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="area"
        label="区域/门店"
        sortable="custom"
        align="center"
        width="140"
        header-align="center" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <div slot="content">
              区域：{{ scope.row.area }} <br/>
              门店：{{ scope.row.store }}
            </div>
            <span>
              {{ `${scope.row.areas && scope.row.areas.length > 0 ?
              scope.row.areas[0].area_name : '未设置'}/${
              scope.row.stores && scope.row.stores.length > 0 ?
              scope.row.stores[0].store_name : '未设置'}` }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        label="设备二维码"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tag
            type="danger"
            size="mini"
            style="cursor: pointer;"
            @click="onDevQrcodeShow(scope.row)"
            disable-transitions>二维码</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="merchant_id"
        label="收款人"
        sortable="custom" >
        <template slot-scope="scope">
          <div v-if="scope.row.merchants.length > 0">
            <el-tooltip placement="top">
              <div slot="content">
                商户ID：{{ scope.row.merchants[0].merchant_id }} <br/>
                收款人：{{ scope.row.merchants[0].acct_name }} <br/>
                商户名：{{ scope.row.merchants[0].stort_name }} <br/>
                开户银行：{{ bankList[scope.row.merchants[0].bank_code] }} <br/>
                开户支行：{{ scope.row.merchants[0].bank_branch }} <br/>
                支付渠道：{{ scope.row.merchants[0].now_pay_channel in payChannelEnum ? payChannelEnum[scope.row.merchants[0].now_pay_channel] : '未知' }}
              </div>
              <span>
                {{ scope.row.merchants.length > 0 ? scope.row.merchants[0].acct_no_encry : '未设置' }}
              </span>
            </el-tooltip>
          </div>
          <div v-else>
            未设置
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="activate"
        label="激活状态"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.activate === 0 ? 'danger' : 'primary'"
            size="mini"
            disable-transitions>{{activateEnum[scope.row.activate]}}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="alive"
        label="在线状态"
        sortable="custom" >
        <template slot-scope="scope">
          <el-tooltip placement="top">
            <el-tag
              :type="scope.row.alive === 0 ? 'danger' : 'primary'"
              size="mini"
              disable-transitions>{{aliveEnum[scope.row.alive]}}</el-tag>
            <span slot="content">
              最后在线时间：{{ scope.row.alive_at | dateformat }} <br/>
              最后离线时间：{{ scope.row.offline_at | dateformat }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="200"
        v-if="hasRes('dev_remote_upgrade') || hasRes('dev_update')">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="onRemoteUpgrade(scope)"
            :disabled="scope.row.alive === 0"
            v-if="hasRes('dev_remote_upgrade')">远程升级</el-button>
          <el-button
            size="mini"
            @click="onDevSetting(scope)"
            type="danger"
            v-if="hasRes('dev_update')">机台设置</el-button>
        </template>
      </el-table-column>
    </custom-table>

    <!--分页-->
    <custom-paginate
      :count="deviceCount"
      v-if="hasRes('dev_index')"
      @page-change="updateTableData">

      <el-button
        type="danger"
        @click="batchDownloadQrcodeDialogVisible = true"
        :disabled="selectedDevs.length === 0">批量下载二维码链接</el-button>
      <el-button
        type="danger"
        @click="batchMigrateDialogVisible = true"
        v-if="hasRes('dev_batch_migrate')"
        :disabled="selectedDevs.length === 0">批量迁移</el-button>
      <el-button
        type="danger"
        @click="onBatchUnbindClick"
        v-if="hasRes('dev_batch_unbind')"
        :disabled="selectedDevs.length === 0">批量解绑</el-button>
    </custom-paginate>

    <!--远程升级弹窗-->
    <dialog-remote-upgrade
      :visible.sync="upgradeDialogVisible"
      v-if="hasRes('dev_remote_upgrade')"
      :upgrade-dev="upgradeDev" />

    <!--绑定二维码弹窗-->
    <dialog-bind-url
      :visible.sync="bindUrlDialogVisible"
      v-if="hasRes('dev_bind_url')"
      @data-change="updateTableData"/>

    <!--批量添加设备-->
    <dialog-batch-add
      :visible.sync="batchAddDialogVisible"
      v-if="hasRes('dev_batch_add')"
      @data-change="updateTableData" />

    <!--机台设置-->
    <dialog-dev-setting
      :visible.sync="devSettingDialogVisible"
      :setting-dev="settingDev"
      v-if="hasRes('dev_update')"
      @data-change="updateTableData" />

    <!--二维码预览-->
    <dialog-qrcode
      ref="dialogQrcode"
      :visible.sync="devQrcodeDialogVisible"
      @wechat-qrcode-add="onWechatQrcodeAddClick"
      :showing-dev="showingDev" />

    <!--批量下载二维码弹窗-->
    <dialog-batch-download-qrcode
      :visible.sync="batchDownloadQrcodeDialogVisible"
      :downloading-devs="selectedDevs" />

    <!--批量迁移设备弹窗-->
    <dialog-batch-migrate
      :visible.sync="batchMigrateDialogVisible"
      :selected-devs="selectedDevs"
      v-if="hasRes('dev_batch_migrate')"
      @data-change="updateTableData" />

    <dialog-wechat-qrcode-editor
      v-model="wechatQrcodeEditingDialogVisible"
      @submit="onWechatQrcodeSubmit"
      v-if="hasRes('wechat_account_qrcode_create')"
      :dev="wechatQrcodeEditingDev" />

  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'

import DevFilterForm from '@/components/dev/DevFilterForm'
import DialogRemoteUpgrade from '@/components/dev/DialogRemoteUpgrade'
import DialogBindUrl from '@/components/dev/DialogBindUrl'
import DialogBatchAdd from '@/components/dev/DialogBatchAdd'
import DialogDevSetting from '@/components/dev/DialogDevSetting'
import DialogQrcode from '@/components/dev/DialogQrcode'
import DialogBatchDownloadQrcode from '@/components/dev/DialogBatchDownloadQrcode'
import DialogBatchMigrate from '@/components/dev/DialogBatchMigrate'
import DialogWechatQrcodeEditor from '@/components/dev/DialogWechatQrcodeEditor'

import bankList from '@/utils/bank'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING, SET_FILTERS } from '@/store/modules/table'

import wechatAccountApi from '@/api/wechatAccountApi'

export default {
  name: 'Device',
  components: {
    CustomTable,
    CustomPaginate,
    DevFilterForm,
    DialogRemoteUpgrade,
    DialogBindUrl,
    DialogBatchAdd,
    DialogDevSetting,
    DialogQrcode,
    DialogBatchDownloadQrcode,
    DialogBatchMigrate,
    DialogWechatQrcodeEditor
  },
  data () {
    return {
      activateEnum: ['未激活', '已激活'],
      aliveEnum: ['离线', '在线'],
      typesEnum: {
        'osm': '线上商城',
        'gpm': '扭蛋机',
        'vm': '自动贩卖机',
        'lpk': '口红机',
        'mc': '脉冲',
        'fdj': '福袋机',
        'gzj': '格子机',
        'undefine': '未知'
      },
      payChannelEnum: {
        'unknown': '未知',
        'sb': '扫呗',
        'jd': '京东',
        'qm': '钱喵'
      },
      bankList: {},

      // 批量入件
      batchAddDialogVisible: false,

      // 绑定二维码
      bindUrlDialogVisible: false,

      // 远程升级相关
      upgradeDialogVisible: false,
      upgradeDev: {},

      // 机台设置
      devSettingDialogVisible: false,
      settingDev: {},

      // 设备二维码
      devQrcodeDialogVisible: false,
      showingDev: {},

      // 批量下载二维码链接
      selectedDevs: [],
      batchDownloadQrcodeDialogVisible: false,

      // 批量迁移设备
      batchMigrateDialogVisible: false,

      // 关注二维码生成
      wechatQrcodeEditingDialogVisible: false,
      wechatQrcodeEditingDev: {}
    }
  },
  computed: {
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters'
    ]),
    ...mapState('device', [
      'deviceList',
      'deviceCount'
    ]),
    ...mapState('factory', [
      'factoryList'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING,
      SET_FILTERS
    ]),
    ...mapActions('device', [
      'getDevices',
      'batchUnbind'
    ]),

    // 复选监听事件
    onSelectionChange (val) {
      this.selectedDevs = val
    },

    onRemoteUpgrade (scope) {
      this.upgradeDev = scope.row
      this.upgradeDialogVisible = true
    },

    onDevSetting (scope) {
      this.settingDev = scope.row
      this.devSettingDialogVisible = true
    },

    onDevQrcodeShow (dev) {
      this.showingDev = dev
      this.devQrcodeDialogVisible = true
    },

    async onBatchUnbindClick () {
      try {
        await this.$confirm('此操作将永久解除所有设备的绑定，是否继续', '设备解绑', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.$confirm('真的真的确定吗？', '设备解绑', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const sns = []
        this.selectedDevs.forEach(dev => {
          sns.push(dev.sn)
        })

        await this.batchUnbind({ sns })
        this.$message({
          type: 'success',
          message: '批量解绑成功'
        })

        this.updateTableData()
      } catch (err) {
        console.log(err)
      }
    },

    onWechatQrcodeAddClick (dev) {
      this.wechatQrcodeEditingDialogVisible = true
      this.wechatQrcodeEditingDev = dev
    },
    async onWechatQrcodeSubmit (formData) {
      try {
        const { rcode, msg } = await wechatAccountApi.addWechatQrcode(formData)
        if (rcode !== 0) {
          this.$message({
            message: msg,
            type: 'error'
          })
          return
        }
        this.$message({
          message: '添加关注二维码成功',
          type: 'success'
        })
        this.$refs['dialogQrcode'].getSubsQrcode()
      } catch (err) {
        console.log(err)
        this.$message({
          message: '添加关注二维码失败',
          type: 'error'
        })
      }
    },

    // 更新表格数据
    updateTableData () {
      this.setLoading(true)

      this.getDevices({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取设备列表失败'
        })
      })
    }
  },
  mounted () {
    this.bankList = bankList

    if ('userid' in this.$route.query) {
      this.setFilters({
        userid: this.$route.query.userid
      })
    }
    this.updateTableData()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/base";

.device-wrapper {

  .op-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/op/Device.vue